import React from "react";
import { classnames, Icon, PlainButton } from "@culturehq/components";

import { t } from "app/utils";

import PageHeader from "components/display/PageHeader";

const phrases = {
  cancel: {
    desc: t("This event will be listed as \"Cancelled\". A cancelled event can't be re-enabled. Guests will still be able to see the event, and add comments."),
    title: t("Cancel this event")
  },
  delete: {
    desc: t("This event will be removed. Guests will no longer be able to see the event's details, or add comments."),
    title: t("Delete this event")
  }
};

const CancelEventType = ({ selected, type, onClick }) => {
  const isActive = type === selected;
  const classList = classnames("cancel-event--type", isActive ? "active" : "inactive");

  const typePhrases = phrases[type];

  return (
    <PlainButton onClick={() => onClick(type)} className={classList}>
      <div className="row">
        <div className="col-xs-2">
          <Icon icon={isActive ? "ios-circle-filled" : "ios-circle-outline"} />
        </div>
        <div className="col-xs-10">
          <PageHeader title={typePhrases.title}>
            {typePhrases.desc}
          </PageHeader>
        </div>
      </div>
    </PlainButton>
  );
};

export default CancelEventType;
